export default "__VITE_ASSET__2fe49991__"